export default theme => ({
    root: {
        position: 'relative',
    },
    form: {
        margin: 'auto',
        padding: 0,
    },
    portletFooter: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
});
